@if (pages) {
  <div class="paginator">
    <button class="btn btn-link" [disabled]="!pages.hasPrevious" (click)="previous()">&lt;&lt;</button>
    <span>Page {{pages.page + 1}} of {{pages.pages}} ({{pages.numberElements}} elements total)</span>
    <button class="btn btn-link" [disabled]="!pages.hasNext" (click)="next()">&gt;&gt;</button>
  </div>
}
